import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { GET_TENANT_INFO_BY_BOOKING_ID } from 'graphql/service';
import { useCustomerForm } from 'customHook/useCustomerForm';
import { setCustomerInfo } from 'redux/actions'
import SubHeader from 'components/SubHeader';
import FooterBar from 'components/FooterBar';
import Button from 'components/Button';
import Spinner from 'components/Spinner';
import GuestInformation from 'components/BookingMain/GuestInformation';
import SideBar from './components/SideBar';
import { Viewing, Remaining } from './components/MobileRemaining';
import Review from './components/Review';
import Image1 from 'assets/icons/male.svg'
import Image2 from 'assets/icons/female.svg'
import Image3 from 'assets/icons/gym.svg'
import {
  MainContainer,
  Content,
  ContentLeft,
  ContentRight,
} from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ReviewPhotos = () => {

  const bookingId = useParams().bookingId
  const dispatch = useDispatch()
  const customerInfo = useSelector(state => state.customerInfoReducer.customerInfo)

  const { data: bookingDetailsData, loading, error } = useQuery(GET_TENANT_INFO_BY_BOOKING_ID, {
    variables: { bookingId: bookingId },
    onCompleted: (bookingDetailsData) => {
      if(bookingDetailsData) {
        const newCustomer = {...customerInfo}
        const tenant = bookingDetailsData.bookingByID?.tenantGroup?.tenant   
        newCustomer.userId = tenant?.user?.userId || ''
        newCustomer.tenantId = tenant?.tenantId || ''
        newCustomer.fullName = tenant?.user?.fullName || ''
        newCustomer.email = tenant?.user?.email || ''
        newCustomer.phoneNumber = tenant?.user?.phoneNumber || ''
        newCustomer.streetAddress = tenant?.user?.address || ''
        newCustomer.streetAddressLine2 = tenant?.user?.addressLine2 || ''
        newCustomer.city = tenant?.user?.city || ''
        newCustomer.province = tenant?.user?.province || ''
        newCustomer.postalCode = tenant?.user?.postalCode || ''
        newCustomer.country = tenant?.user?.country || ''
        newCustomer.dateOfBirth = tenant?.user?.dateOfBirth || ''
        //FIXME: document value
        newCustomer.travelDocumentNumber = ''
        newCustomer.travelDocumentType = ''
        dispatch(setCustomerInfo(newCustomer))
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  })

  const [customerInfoError, setCustomerInfoError] = useState({})
  const { updateCustomerInfo } = useCustomerForm(setCustomerInfoError);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  //FIXME: Replace with real data
  const flagAsInvalidLoading=false
  const approveLoading=false

  const handleFlagAsInvalid = () => {
    if(flagAsInvalidLoading) return
    //TODO: Implement flag as invalid logic
  }

  const handleApprove = () => {
    if(approveLoading) return
    //TODO: Implement approve logic
  }
  
  return (
    <>
      <Helmet>
        <title>Review Photos - Rook Hotel PMS</title>
        <meta name="description" content="Review Photos - Rook Hotel PMS" />
      </Helmet>
      <SubHeader> 
        <div className='title'>
          Review Photos
        </div>
        <div
          className='buttonContainer'
          style={{paddingRight: '20%'}}
        >
          <Button
            mainPage
            danger
            onClick={handleFlagAsInvalid}
            data-loading={flagAsInvalidLoading}
            additionalstyle={`
              width: 115px;
            `}
          >
            {flagAsInvalidLoading? null : 'Flag as invalid'}
          </Button>
          <Button
            mainPage
            onClick={handleApprove}
            data-loading={approveLoading}
            additionalstyle={`
              width: 81px;
              margin-left: 14px;
              margin-right: 7px;
            `}
          >
            {approveLoading? null : 'Approve'}
          </Button>
        </div>
      </SubHeader>
      <MainContainer>
        <ContentLeft>
          <Content>
            <Viewing remaining={[]} bookingId={bookingId} />
            <Review
              imageSources={[Image1,Image2,Image3]}
              handleFlagAsInvalid={handleFlagAsInvalid}
              flagAsInvalidLoading={flagAsInvalidLoading}
              handleApprove={handleApprove}
              approveLoading={approveLoading}
            />
            <GuestInformation customerInfoError={customerInfoError} />
            <Remaining remaining={[]} bookingId={bookingId} />
          </Content>
        </ContentLeft>
        <ContentRight>
          <SideBar remaining={[]} bookingId={bookingId} />
        </ContentRight>
      </MainContainer>
      <FooterBar />
    </>
  );
};

export default ReviewPhotos;
